module.exports = __webpack_public_path__ + "static/lastgen-slr-trees-ed956ef7ab7f9360b8272095bf404c82.webm";